import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {PreviewAvatar} from '@Components/social-media/components/social-post-content-multiposting/components/preview-avatar/preview-avatar';
import {PreviewAvatarShape} from '@Components/social-media/components/social-post-content-multiposting/components/preview-avatar/preview-avatar.types';
import {VerticalVideoAccountName} from '../vertical-video-account-name/vertical-video-account-name';
import {VerticalVideoActionIcons} from '../vertical-video-action-icons/vertical-video-action-icons';
import {VerticalVideoCaptionLine} from '../vertical-video-caption-line/vertical-video-caption-line';
import {VerticalVideoScrim} from '../vertical-video-scrim/vertical-video-scrim';
import type {YoutubeOverlayProps} from './youtube-overlay.types';
import {YOUTUBE_SHORTS_ACTION_ICONS} from './youtube-overlay.types';
import styles from './youtube-overlay.module.scss';

export function YoutubeOverlay({account, caption}: YoutubeOverlayProps): ReactElement {
  const getScrim = (): ReactElement => {
    return <VerticalVideoScrim className={styles.youtubeOverlayScrim} />;
  };

  const getCaptionBlock = (): ReactElement => {
    return (
      <div className={styles.youtubeOverlayCaptionBlock}>
        {getIdentityRow()}
        <VerticalVideoCaptionLine caption={caption} moreClassName={styles.youtubeOverlayCaptionMore} />
      </div>
    );
  };

  const getIdentityRow = (): ReactElement => {
    return (
      <div className={styles.youtubeOverlayIdentityRow}>
        <PreviewAvatar account={account} className={styles.youtubeOverlayAvatar} />
        <VerticalVideoAccountName accountName={account.name} />
        {getSubscribePill()}
      </div>
    );
  };

  const getSubscribePill = (): ReactElement => {
    return (
      <div className={styles.youtubeOverlaySubscribePill}>
        <Text bold className={styles.youtubeOverlaySubscribeLabel} size={TextSize.XS} val={window.i18next.t('pmwjs_subscribe')} />
      </div>
    );
  };

  const getActionRail = (): ReactElement => {
    return (
      <div className={styles.youtubeOverlayActionRail}>
        <VerticalVideoActionIcons iconNames={YOUTUBE_SHORTS_ACTION_ICONS} />
        {getAudioCoverThumbnail()}
      </div>
    );
  };

  const getAudioCoverThumbnail = (): ReactElement => {
    return <PreviewAvatar account={account} className={styles.youtubeOverlayAudioCover} shape={PreviewAvatarShape.ROUNDED_SQUARE} />;
  };

  return (
    <>
      {getScrim()}
      {getCaptionBlock()}
      {getActionRail()}
    </>
  );
}
